export const EVENT_TOUR_KEY = 'event';

export const eventTourSteps = [
  {
    target: 'event-list',
    title: 'Anwesenheitsliste',
    description: 'Hier siehst du alle angemeldeten Spieler für diesen Spieltag — aufgeteilt in Teilnehmer und Warteliste.',
  },
  {
    target: 'event-list',
    title: 'Doppelklick → Anwesenheit setzen',
    description: 'Doppelklick auf einen Spieler wechselt seinen Anwesenheitsstatus zwischen "Anwesend" und "Abwesend".',
  },
  {
    target: 'event-list',
    title: 'Langer Klick → Kontextmenü',
    description: 'Halte einen Spieler gedrückt, um das Kontextmenü zu öffnen. Von dort aus kannst du anrufen, bearbeiten (z. B. Zusätze wie Leihausrüstung ändern) oder im Event gekaufte Artikel wie BBs buchen.',
  },
  {
    target: 'event-add-form',
    mobileTarget: 'create-form-toggle',
    title: 'Spieler hinzufügen',
    description: 'Gib mindestens ein Feld ein (z. B. nur den Nachnamen). Danach öffnet sich ein Popup — falls der Spieler schon in der Datenbank ist, wähle ihn aus der Vorschlagsliste. So vermeidest du doppelte Einträge.',
  },
  {
    target: 'nav-settings',
    mobileTarget: 'nav-settings-mobile',
    title: 'Icon-Legende',
    description: 'Eventuell siehst du verschiedene kleine Icons und Symbole bei den Spielern. Was jedes Symbol bedeutet, findest du jederzeit unter "Icon-Legende" — erreichbar über die Sidebar oder das Mehr-Menü.',
  },
];
